import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/** Facebook general search results (mobile): the image card with the page and copy under it. */
@Component({
  selector: 'app-meta-facebook-search-mobile',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-search-mobile.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './facebook-search-mobile.component.scss'
})
export class MetaFacebookSearchMobilePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** The first paragraph, up to 125 characters; the "…" marks the rest. */
  get primaryText(): TruncatedCopy {
    return MetaPreviewCopy.firstParagraph(MetaPreviewCopy.primaryText(this.data), 125);
  }
}
